import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Paper,
  Rating,
  Typography,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import HeroImg from "../../images/homeImg/heroimg.jpg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Serviceimg from "../../images/howthis/Layer_1.svg";
import Requirements from "../../images/howthis/Character_1.svg";
import Requtes from "../../images/howthis/Character.svg";
import PortfolioCarousel from "../portfolio";
import Header from "../../Layout/Header/header";
import Footer from "../../Layout/Footer/footer";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authcontext";
import { useNavigate } from "react-router-dom";
import { API_CONFIG } from "../../api/apiUrl";
import { motion } from "framer-motion";
import LeftArrowIcon from "../../images/sliderArrow/Left Arrow.svg";
import RightArrowIcon from "../../images/sliderArrow/Right Arrow.svg";

const contentVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

const contentTransition = {
  type: "spring",
  stiffness: 120,
  damping: 20,
  duration: 0.3,
};

interface ContractorType {
  id: number;
  name: string;
  description: string;
  imgUrl: string;
  isDeleted: boolean;
  isActive: boolean;
}

const Home = () => {
  const authContext = useContext(AuthContext);
  const [contractorTypes, setContractorTypes] = useState<ContractorType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  if (!authContext) throw new Error("Home must be used within an AuthProvider");

  const { isAuthenticated, loading: authLoading } = authContext;

  const fetchContractorTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_CONFIG.CONTRACTOR_TYPES);
      setContractorTypes(response.data);
      setLoading(false);
    } catch (err) {
      // setError('Failed to fetch contractor types');
      setLoading(false);
      console.error("Error fetching contractor types:", err);
    }
  };

  useEffect(() => {
    fetchContractorTypes();
  }, []);

  const handleServiceSelect = (service: ContractorType) => {
    navigate("/plot-details", {
      state: {
        selectedService: service,
      },
    });
  };

  return (
    <>
      <Box sx={{ maxWidth: "2000px", margin: "0 auto" }}>
        <Header />
        <Box sx={{ flex: 1 }}>
          <motion.div
            variants={contentVariants}
            initial="initial"
            animate="in"
            exit="out"
            transition={contentTransition}
          >
            {/* ===================== Hero Section Start ================== */}
            <Box
              sx={{
                py: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 },
                px: { xs: 2, md: 6.4 },
              }}
            >
              <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
                <Grid item xs={12} md={5}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                          <Typography
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontWeight: 700,
                              color: "#89652A",
                              fontSize: { xs: "30px", md: "50px" },
                            }}
                          >
                            Meegloo
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize:'20px',
                          maxWidth: "90%",
                        }}
                      >
                        Your One-Stop Solution for Home Construction, Interiors,
                        Renovations.
                      </Typography>
                    </Grid>
                    {authLoading ? (
                      <Grid item xs={12}>
                        <Skeleton
                          variant="rounded"
                          width={150}
                          height={40}
                          style={{ background: "white" }}
                        />
                      </Grid>
                    ) : (
                      !isAuthenticated && (
                        <Grid item xs={12}>
                          <Link to="/choose">
                            <Button
                              sx={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize:"20px",
                                borderRadius: "25px",
                                border: "1px solid #89652A",
                                textTransform: "capitalize",
                                color: "#89652A",
                                fontWeight: 700,
                                padding: "4px 22px",
                              }}
                            >
                              Let's Get Started
                            </Button>
                          </Link>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 4,
                      overflow: "hidden",
                      height: { xs: 300, md: 318 },
                    }}
                  >
                    <img
                      src={HeroImg}
                      alt="hero-img"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            {/* ===================== Hero Section Closed ================== */}

            {/* ===================== civil contractor section start ================== */}
            <Box sx={{ background: "#FAFAFA" }}>
              <Box sx={{ py: { xs: 4, md: 2 } }}>
                <Box sx={{ py: { xs: 1, md: 2 }, px: { xs: 1.5, md: 7.5 } }}>
                  <Typography
                    sx={{
                      my: { xs: 1, md: 2 },
                      fontSize: { xs: "30px", md: "40px" },
                      textTransform: "capitalize",
                      fontWeight: 700,
                      color:"#333333"
                    }}
                  >
                    Select Service
                  </Typography>
                  <Grid
                    container
                    spacing={{ xs: 0.2, md: 2 }}
                    justifyContent="center"
                  >
                    {loading ? (
                      <></>
                    ) : error ? (
                      <Typography color="error">{error}</Typography>
                    ) : (
                      contractorTypes.map((service, index) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={3}
                          key={index}
                          onClick={() => handleServiceSelect(service)}
                        >
                          <Box sx={{ cursor: "pointer" }}>
                            <Card
                              elevation={0}
                              sx={{
                                borderRadius: "27px",
                                m: { xs: 0.5, md: 1 },
                                boxShadow:
                                  "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  backgroundColor: "white",
                                }}
                              >
                                <img
                                  src={service.imgUrl}
                                  alt={service.name}
                                  height={120}
                                />
                              </CardContent>
                            </Card>
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: "20px", 
                                whiteSpace: { xs: "normal", md: "nowrap" }, 
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                lineHeight: 1.3, 
                                mt:2,
                                maxWidth: "100%",
                                px: { xs: 1, md: 0 },
                              }}
                              mt={1.3}
                            >
                              {service.name}
                            </Typography>
                          </Box>
                        </Grid>
                      ))
                    )}
                  </Grid>
                </Box>
              </Box>
            </Box>
            {/* ===================== civil contractor section Closed ================== */}

            {/* ===================== How its Work section Start ================== */}
            <Box sx={{ pt: { xs: 2, md: 2 }, px: { xs: 0, md: 3 } }}>
              <Typography
                sx={{
                  my: { xs: 1, md: 2 },
                  fontSize: { xs: "30px", md: "50px" },
                  fontWeight: 700,
                  textAlign: "center",
                  color: "#333333",
                }}
              >
                How This Works
              </Typography>
              <Carousel
                responsive={responsiveOne}
                infinite={true}
                arrows={true}
                autoPlay={true}
                autoPlaySpeed={4000}
                containerClass="carousel-container"
                showDots={false}
                partialVisible={true}
                renderDotsOutside={true}
                customLeftArrow={<CustomLeftArrow />}
                customRightArrow={<CustomRightArrow />}
              >
                {HowThis.map((service, index) => (
                  <Box key={index} className="carousel-item">
                    <Card
                      elevation={0}
                      sx={{
                        borderRadius: 2,
                        border: "1px solid #E2DFDF",
                        m: 2,
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          backgroundColor: "white",
                        }}
                      >
                        <img
                          src={service.image}
                          alt={service.title}
                          height={200}
                        />
                      </CardContent>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontWeight: 500,
                          fontSize: "20px",
                        }}
                        mb={1}
                      >
                        {service.title}
                      </Typography>
                    </Card>
                  </Box>
                ))}
              </Carousel>
            </Box>
            {/* ===================== How its Work section Closed ================== */}

            {/* ===================== Portfolio section start ================== */}
            {/* <Box sx={{ py: { xs: 1, md: 3 }, px: { xs: 0 } }}>
              <PortfolioCarousel />
            </Box> */}
            {/* ===================== Portfolio section Closed ================== */}

            {/* ===================== What people say about us start ================== */}
            <Box>
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  mt: { xs: 1, md: 0.5 },
                  fontSize: { xs: "27px", md: "50px" },
                  fontWeight: 700,
                  textAlign: "center",
                  color: "#333333",
                }}
              >
                What People Say About Us
              </Typography>
              <Carousel
                responsive={responsive}
                swipeable
                draggable
                customTransition="transform 500ms ease-in-out"
                transitionDuration={500}
                infinite
                autoPlay
                autoPlaySpeed={2000}
                keyBoardControl
                arrows={false}
                showDots
                dotListClass="custom-dot-list"
                className="say-about-us-dots-height"
              >
                {testimonials.map((testimonial, index) => (
                  <Card
                    elevation={0}
                    key={index}
                    sx={{
                      borderRadius: "20px",
                      p: 2,
                      backgroundColor: "#f4f4f4",
                      display: "flex",
                      alignItems: "center",
                      m: 2,
                    }}
                  >
                    <Avatar
                      src={testimonial.image}
                      alt={testimonial.name}
                      sx={{
                        boxShadow:
                          "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
                        width: 120,
                        border: "1px solid #FFFFFF",
                        height: 180,
                        borderRadius: { xs: "35px", md: "46px" },
                        mr: 2,
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontWeight: 700, fontSize: "22px", mb: 1 }}
                      >
                        {testimonial.name}
                      </Typography>
                      <Rating
                        name="read-only"
                        value={testimonial.rating}
                        readOnly
                        size="small"
                        sx={{ mb: 2, color: "black" }}
                      />
                      <Typography sx={{ fontSize: "13px", fontWeight: 400 }}>
                        {testimonial.message}
                      </Typography>
                    </Box>
                  </Card>
                ))}
              </Carousel>
            </Box>
            {/* ===================== What people say about us Closed ================== */}
          </motion.div>
        </Box>

        <Footer />
      </Box>
    </>
  );
};

export default Home;

const HowThis = [
  {
    title: "Select The Service",
    image: Serviceimg,
  },
  {
    title: "Enter Requirements",
    image: Requirements,
  },
  {
    title: "Request Quotes",
    image: Requtes,
  },
  {
    title: "Confirm and Book",
    image: Requtes,
  },
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1.3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const testimonials = [
  {
    name: "Anita Sharma",
    rating: 5,
    message:
      "Meegloo made our home renovation seamless! Their team connected us with top-notch interior contractors who transformed our space beyond expectations.",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e", 
  },
  {
    name: "Rahul Verma",
    rating: 4.5,
    message:
      "Building our dream home was stress-free with Meegloo. The platform's quote comparison feature saved us time and money. Highly recommend their services!",
    image: "https://images.unsplash.com/photo-1613145998136-df0ebd29b67a", 
  },
  {
    name: "Priya Singh",
    rating: 4,
    message:
      "Meegloo's user-friendly interface helped us find reliable civil contractors quickly. The project management support was fantastic throughout!",
    image: "https://images.unsplash.com/photo-1613553480366-4f3e12e96e3f", 
  },
];


const responsiveOne = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

// Custom Arrow Components
const CustomLeftArrow = ({ onClick, ...rest }: any) => (
  <button
    onClick={onClick}
    style={{
      background: "transparent",
      border: "none",
      borderRadius: "50%",
      width: 48,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "none",
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      cursor: "pointer",
      padding: 0,
    }}
    aria-label="Previous"
    {...rest}
  >
    <span style={{
      background: "white",
  
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
   
    }}>
      <img src={LeftArrowIcon} alt="Previous" style={{ width: 28, height: 28, background: 'transparent', border: 'none' }} />
    </span>
  </button>
);

const CustomRightArrow = ({ onClick, ...rest }: any) => (
  <button
    onClick={onClick}
    style={{
      background: "transparent",
      border: "none",
      borderRadius: "50%",
      width: 48,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "none",
      position: "absolute",
      right: 10,
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      cursor: "pointer",
      padding: 0,
    }}
    aria-label="Next"
    {...rest}
  >
    <span style={{
      background: "white",
   
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

    }}>
      <img src={RightArrowIcon} alt="Next" style={{ width: 28, height: 28, background: 'transparent', border: 'none' }} />
    </span>
  </button>
);
